import dayjs from "dayjs";
import weekday from "dayjs/plugin/weekday";
import localeData from "dayjs/plugin/localeData";
import "dayjs/locale/zh-cn";
import "dayjs/locale/en";
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.locale("zh-cn");

export default dayjs;
